// AgencyJobsShowTabs' read (finance-real, the user 2026-10-22): each status tab's count, from the Jobs tab's own read.
import type { UseQueryResult } from "@tanstack/react-query";
import { useAgencyJobs } from "../../hooks/useLineJobs";
import type { AgencyJobsResponse } from "../../types";

export function useAgencyJobsShowTabs(): UseQueryResult<AgencyJobsResponse> {
  return useAgencyJobs();
}
